import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../core/auth/services/auth.service';
import { ICommentRequest, ICreateComment } from '../../features/models';
import { ISessionToken } from '@core/models';
import config from '../../../config';

@Injectable({
  providedIn: 'root',
})
export class CommentsService {
  apiUrl = config.API_GATEWAY_ENDPOINT;
  prid = '';

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService,
  ) {
    this.authService
      .amplifyGetUserSession()
      .forEach((session: ISessionToken) => {
        this.prid = this._extractPridFromSession(session);
      });
  }

  async createComment(
    id_project: string,
    comment: string,
  ): Promise<ICreateComment> {
    const body: ICommentRequest = {
      id_project,
      prid: this.prid,
      comment,
    };

    try {
      const response = await lastValueFrom(
        this.http.post<ICreateComment>(`${this.apiUrl}/comments`, body),
      );
      return response;
    } catch (error) {
      console.error('Error creating comment:', error);
      throw error;
    }
  }

  _extractPridFromSession(session: ISessionToken): string {
    if (session?.tokens?.accessToken?.payload?.username) {
      const pridToken = session.tokens.accessToken.payload.username;
      const email = pridToken.split('@')[0];
      return email.split('_')[1] || email;
    }
    return '';
  }
}
